"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixpanelUserProperty = exports.MixpanelEventType = void 0;
var MixpanelEventType;
(function (MixpanelEventType) {
    MixpanelEventType["SlackDigestDispatch"] = "Slack digest dispatch";
    MixpanelEventType["SlackDigestEvent"] = "Slack digest event";
    MixpanelEventType["SprintSelection"] = "Sprint selection";
    MixpanelEventType["SprintReviewCustomization"] = "Sprint review customization";
    MixpanelEventType["SprintReviewSelect"] = "Sprint review select";
    MixpanelEventType["SprintReviewAvatarSelection"] = "Sprint review avatar selection";
    MixpanelEventType["TellerCustomerCreated"] = "Teller customer created";
    MixpanelEventType["TellerStartedFreeTrial"] = "Teller started free trial";
    MixpanelEventType["GoRetroSprintReviewNotifierSent"] = "Integration complete email sent";
    MixpanelEventType["GoRetroSprintReviewNotifierFailed"] = "Integration complete email failed";
    MixpanelEventType["TellerCheckoutSessionCreated"] = "Teller checkout session created";
    MixpanelEventType["TellerWebhook"] = "Teller webhook";
    MixpanelEventType["TellerCustomerCardUpdated"] = "Teller customer card updated";
    MixpanelEventType["UserSubscriptionChanged"] = "User subscription changed";
    MixpanelEventType["MemeMakerClick"] = "User clicked on meme maker link in 2nd fetch";
    MixpanelEventType["UserSelectedSprints"] = "User selected sprints";
    MixpanelEventType["UserStartedPokerGame"] = "User started a poker game";
    MixpanelEventType["UserCopiedPokerInvitationLink"] = "User copied poker invitation link";
    MixpanelEventType["UserImportedIssuesToPoker"] = "User imported issues to poker";
    MixpanelEventType["UserExportedIssuesFromPoker"] = "User exported issues from poker";
    MixpanelEventType["JiraIntegrationDisconnected"] = "Jira integration disconnected";
    MixpanelEventType["UserAddedCommentToPlanningPokerTask"] = "User added comment to planning poker task";
    MixpanelEventType["UserDeletedCommentOfPlanningPokerTask"] = "User deleted comment of planning poker task";
    MixpanelEventType["UserFailedToAddACommentToPlanningPokerTask"] = "User failed to add a comment to planning poker task";
    MixpanelEventType["JiraConnectClicked"] = "Jira connect clicked";
    MixpanelEventType["JiraReconnectClicked"] = "Jira reconnect clicked";
})(MixpanelEventType = exports.MixpanelEventType || (exports.MixpanelEventType = {}));
var MixpanelUserProperty;
(function (MixpanelUserProperty) {
    MixpanelUserProperty["StripeSubscriptionStatus"] = "Stripe subscription status";
    MixpanelUserProperty["AcumenSubscriptionStatus"] = "Acumen subscription status";
    MixpanelUserProperty["BillingPeriodEnd"] = "Subscription is due to renew at";
    MixpanelUserProperty["BillingFrequency"] = "Billing frequency";
})(MixpanelUserProperty = exports.MixpanelUserProperty || (exports.MixpanelUserProperty = {}));
//# sourceMappingURL=mixpanel.js.map